import { toastError } from "../../toasts";
import { BaBase } from "./ba-base.js";
import { BonusAddAi } from "./bonus-add-ai";

export class BaProcessing extends BaBase {
    static override webComponentName: string = "ba-processing";
    protected override _templateId: string = "ba-processing";
    private _internalState: 'process' | 'ask' = 'ask';
    public get internalState(): 'process' | 'ask' {
        return this._internalState;
    }
    public set internalState(value: 'process' | 'ask') {
        this._internalState = value;
        this.dispatch('internal-state-change', { state: this._internalState });
    }
    constructor() {
        super();
    }
    protected onConnected(): void {
        this.setupListeners();
        super.onConnected();
    }
    private setupListeners(): void {
        this.addEventListener('internal-state-change', (ev: Event) => {
            ev.stopPropagation();
            const detail = (ev as CustomEvent).detail;
            if (detail && detail.state) {
                this.render();
                if(detail.state ==="process" ) {
                    this.bonusAnalyze();
                }
            }
        })
        this.on('click', '[role="bonus-analyze"]', (e: Event) => {
            this.internalState = 'process';
        });
        this.on('click', '[role="reset"]', (e: Event) => {
            console.log("BaProcessing: Resetting to initial state.");
            if (this.BaParent) {
                this.BaParent.step = 'initial';
            }
        });
    }
    async bonusAnalyze(): Promise<any> {
        if (!this.BaParent || !this.BaParent.currentFile || !this.BaParent.currentFile.base64) {
            this.onProcessingError('Nessun file da processare.');
            return;
        }
        try {
            const response = await window.api.bonusAnalyze(this.BaParent.currentFile.base64);
            if (response.success && response.data) {
                if (this.BaParent) {
                    // salvo i dati in sessionStorage per recuperarli nella pagina di aggiunta bonus
                    this.BaParent.currentAnalysData = response.data;
                }
                return response.data;
            }
            else {
                this.onProcessingError(response.message || 'Errore durante l\'analisi del file.');
            }
        }
        catch (error) {
            this.onProcessingError('Errore durante l\'analisi del file.');
            return;
        }
    }
    onProcessingError(message: string) {
        if (this.BaParent) {
            toastError(message);
            this.BaParent.currentFile = null;
        }
    }
protected buildRenderingData(): Record<string, any> {
        const baseData = super.buildRenderingData();
        return {
            filename : this.BaParent.currentFile.name,
            internalState: this.internalState,
            ...baseData
        };
}
    protected afterRender(): void {
        super.afterRender();
        
    }
    protected render(): void {
        super.render();
    }
}